module.exports = __webpack_public_path__ + "img/89.6be3d524.jpg";